import { Placement } from '@spectrum-web-components/overlay'
import styles from '@styles/components/RichTooltip.module.scss'
import React, { FC } from 'react'
import { Tooltip } from 'ui'

export type RichTooltipProps = {
  delayed?: boolean
  description: string
  keybind?: string
  offsetPx?: number
  placement: Placement
  selfManaged: boolean
  slot?: string
  title: string
  videoSources: Array<{
    src: string
    type: 'webm' | 'mp4'
  }>
}

export const RichTooltip: FC<RichTooltipProps> = ({
  delayed = true,
  description,
  keybind,
  offsetPx = 18,
  placement,
  selfManaged,
  slot,
  title,
  videoSources
}) => {
  return (
    <Tooltip
      data-testid="rich-tooltip-tooltip"
      delayed={delayed}
      slot={slot}
      selfManaged={selfManaged}
      placement={placement}
      offset={selfManaged ? offsetPx : undefined}
      className={styles['rich-tooltip']}
      style={
        {
          '--mod-tooltip-margin': selfManaged ? undefined : `${offsetPx}px`
        } as React.CSSProperties
      }
    >
      <div className={styles['rich-tooltip-content']}>
        <video
          className={styles['rich-tooltip-video']}
          data-testid="rich-tooltip-video"
          autoPlay
          muted
          loop
          playsInline
        >
          {videoSources.map(({ src, type }) => (
            <source key={src} src={src} type={`video/${type}`} />
          ))}
        </video>
        <div className={styles['rich-tooltip-text-container']}>
          <div className={styles['rich-tooltip-heading']}>
            <div
              className={styles['rich-tooltip-title']}
              data-testid="rich-tooltip-title"
            >
              {title}
            </div>
            {keybind && (
              <div
                className={styles['rich-tooltip-keybind']}
                data-testid="rich-tooltip-keybind"
              >
                {keybind}
              </div>
            )}
          </div>
          <div
            className={styles['rich-tooltip-description']}
            data-testid="rich-tooltip-description"
          >
            {description}
          </div>
        </div>
      </div>
    </Tooltip>
  )
}
